/* eslint-disable */
import React, { useRef, useState, useEffect } from 'react'
import {
  faCircleExclamation,
  faEye,
  faEyeSlash,
  faCircle,
} from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import logo from '../img/swb-logo-heart.png'
import { Link, useNavigate, useSearchParams } from 'react-router-dom'
import bg from '../img/resetpassword.png'

import axios from '../api/axios'

const PWD_REGEX = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%]).{8,24}$/
const RESET_URL = '/reset-password'

const ResetPassword = () => {
  let [searchParams] = useSearchParams()

  const navigate = useNavigate()

  const passwordRef = useRef()
  const errRef = useRef()

  const [pwd, setPwd] = useState('')
  const [validPwd, setValidPwd] = useState(false)

  const [matchPwd, setMatchPwd] = useState('')
  const [validMatch, setValidMatch] = useState(false)

  const [newPwd, setNewPwd] = useState('')
  const [confirmPwd, setConfirmPwd] = useState('')
  const [showPwd, setShowPwd] = useState(false)
  const [showConfirmPwd, setShowConfirmPwd] = useState(false)

  const [pwdCriteria, setPwdCriteria] = useState({
    upper: false,
    number: false,
    special: false,
    minLength: false,
  })

  const PASSWORD_REGEX = {
    upper: /[A-Z]/,
    number: /[0-9]/,
    special: /[!@#$%^&*(),.?":{}|<>]/,
    minLength: /.{8,}/,
  }
  const FORGOT_PWD_URL = '/forgot-password'

  const allCriteriaMet = Object.values(pwdCriteria).every(Boolean)
  const passwordsMatch = newPwd === confirmPwd
  const canSubmit = allCriteriaMet && passwordsMatch

  const [errMsg, setErrMsg] = useState('')
  const [error, setError] = useState(false)
  const token = searchParams.get('token')

  useEffect(() => {
    if (!token) {
      navigate('/forgot-password', { replace: true })
    }
  }, [token])

  useEffect(() => {
    setErrMsg('')
  }, [newPwd, confirmPwd])

  useEffect(() => {
    setPwdCriteria({
      upper: PASSWORD_REGEX.upper.test(newPwd),
      number: PASSWORD_REGEX.number.test(newPwd),
      special: PASSWORD_REGEX.special.test(newPwd),
      minLength: PASSWORD_REGEX.minLength.test(newPwd),
    })
  }, [newPwd])

  useEffect(() => {
    const result = PWD_REGEX.test(pwd)
    setValidPwd(result)
    const match = pwd === matchPwd
    setValidMatch(match)
  }, [pwd, matchPwd])

  useEffect(() => {
    setErrMsg('')
  }, [pwd, matchPwd])

  const renderDot = (valid) => (
    <FontAwesomeIcon
      icon={faCircle}
      className={`text-xs ${valid ? 'text-green-500' : 'text-gray-400'}`}
    />
  )

  const handleSubmit = async (e) => {
    e.preventDefault()

    if (newPwd !== confirmPwd) {
      setErrMsg('Passwords do not match.')
      return
    }

    const meetsAll = Object.values(pwdCriteria).every(Boolean)
    if (!meetsAll) {
      setErrMsg('Password does not meet the criteria.')
      return
    }

    if (!token) {
      setErrMsg('Invalid or missing token.')
      return
    }

    try {
      const response = await axios.post('/reset-password', {
        token: token,
        password: newPwd,
        password_confirmation: confirmPwd,
      })

      setPwd('')

      navigate('/login', {
        state: { success: 'Password successfully reset. Please log in.' },
      })
    } catch (error) {
      if (error.response?.data?.invalid_token) {
        setErrMsg('This reset link is invalid or has expired.')
      } else {
        setErrMsg('Something went wrong. Please try again.')
      }
    }
  }

  return (
    <div
      className="min-h-screen bg-cover bg-center px-8 relative"
      style={{ backgroundImage: `url(${bg})` }}
    >
      <div className="md:flex md:items-center md:justify-between">
        <div className="md:absolute top-[10%] md:right-[12%] lg:right-[10%] xl:right[15%] max-w-xl w-full mx-auto">
          {/* Inner container with background via ::before */}
          <div className="relative px-4 py-4 space-y-4 md:space-y-6">
            <div className="relative z-10">
              <div className="pt-16 md:pt-0 flex items-center gap-3 pb-2 leading-tight tracking-wider text-[#360F41] dark:text-white">
                <img src={logo} alt="SWB Logo" className="h-20 w-auto" />
                <div>
                  <h1 className="text-2xl md:text-3xl font-bold">
                    School Wellbeing Staff Portal
                  </h1>
                </div>
              </div>
              <h2 className="text-3xl text-wba-primary font-bold text-center mb-6">
                Reset Password
              </h2>
            </div>

            {error ? (
              <div>
                <h1 className="text-2xl text-wba-primary font-bold text-center mb-2">
                  Token Expired
                </h1>
                <p className="text-center">
                  We could not reset your password as the token used has
                  expired. Please go to{' '}
                  <span
                    className="text-blue-500 cursor-pointer"
                    onClick={() =>
                      navigate('/forgot-password', { replace: true })
                    }
                  >
                    Forgot Password
                  </span>{' '}
                  and try again.
                </p>
              </div>
            ) : (
              <div
                className="relative px-4 py-6 md:p-8 space-y-4 md:space-y-6 
                      bg-white/90 shadow-lg rounded-lg  
                        lg:bg-transparent lg:shadow-none lg:opacity-100"
              >
                <div className="">
                  <p
                    ref={errRef}
                    className={errMsg ? 'errmsg' : 'offscreen'}
                    aria-live="assertive"
                  >
                    {errMsg}
                  </p>
                  <div>
                    <form
                      onSubmit={handleSubmit}
                      className=" space-y-4 md:space-y-6"
                    >
                      <div className="">
                        {/* New Password */}
                        <label className="block mb-2 text-sm font-medium text-gray-700 dark:text-white">
                          New Password
                        </label>
                        <div className="relative">
                          <input
                            type={showPwd ? 'text' : 'password'}
                            value={newPwd}
                            onChange={(e) => setNewPwd(e.target.value)}
                            required
                            placeholder="New Password"
                            autoComplete="new-password"
                            className="bg-gray-50 border border-gray-300 text-gray-900 sm:text-sm rounded-lg focus:outline-none focus:border-violet-300 focus:ring-1 focus:ring-violet-300 block w-full p-2.5 pr-10"
                          />
                          <button
                            type="button"
                            onClick={() => setShowPwd(!showPwd)}
                            className="absolute right-2 top-1/2 transform -translate-y-1/2 text-gray-500"
                            tabIndex={-1}
                          >
                            <FontAwesomeIcon
                              icon={showPwd ? faEyeSlash : faEye}
                            />
                          </button>
                        </div>

                        {/* Confirm Password */}
                        <label className="block mt-4 mb-2 text-sm font-medium text-gray-700 dark:text-white">
                          Confirm Password
                        </label>
                        <div className="relative">
                          <input
                            type={showConfirmPwd ? 'text' : 'password'}
                            value={confirmPwd}
                            onChange={(e) => setConfirmPwd(e.target.value)}
                            required
                            placeholder="Confirm Password"
                            autoComplete="new-password"
                            className="bg-gray-50 border border-gray-300 text-gray-900 sm:text-sm rounded-lg focus:outline-none focus:border-violet-300 focus:ring-1 focus:ring-violet-300 block w-full p-2.5 pr-10"
                          />
                          <button
                            type="button"
                            onClick={() => setShowConfirmPwd(!showConfirmPwd)}
                            className="absolute right-2 top-1/2 transform -translate-y-1/2 text-gray-500"
                            tabIndex={-1}
                          >
                            <FontAwesomeIcon
                              icon={showConfirmPwd ? faEyeSlash : faEye}
                            />
                          </button>
                        </div>

                        {/* Passwords don't match error */}
                        {confirmPwd && newPwd !== confirmPwd && (
                          <p className="text-xs text-rose-500 mt-1 flex items-center">
                            <FontAwesomeIcon
                              icon={faCircleExclamation}
                              className="mr-1"
                            />
                            Passwords don't match
                          </p>
                        )}

                        {/* Criteria */}
                        <div className="mt-4 space-y-1 text-sm">
                          <p>
                            {renderDot(pwdCriteria.upper)} At least 1 uppercase
                            letter
                          </p>
                          <p>
                            {renderDot(pwdCriteria.number)} At least 1 number
                          </p>
                          <p>
                            {renderDot(pwdCriteria.special)} At least 1 special
                            character
                          </p>
                          <p>
                            {renderDot(pwdCriteria.minLength)} Minimum of 8
                            characters
                          </p>
                        </div>

                        <div>
                          <input
                            type="submit"
                            value="Reset Password"
                            disabled={!canSubmit}
                            className={`w-full py-2 text-white rounded-md mt-4 
                                ${
                                  canSubmit
                                    ? 'bg-hub-primary hover:bg-hub-primary-hover cursor-pointer'
                                    : 'bg-gray-300 cursor-not-allowed'
                                }
                              `}
                          />
                        </div>
                      </div>
                    </form>
                    <div className="relative mt-4 font-bold text-wba-primary text-xs flex justify-center z-10">
                      <Link to="/login" className="hover:text-blue-800">
                        Already have an account? Login here
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  )
}

export default ResetPassword
